module.exports = __webpack_public_path__ + "static/img/play.f32345f0.png";